import React from 'react'

import { Suggestion } from '@components/common/Suggestion'
import { routing } from '@utils/routing'

import type { Promotion } from '../../../../../pages/Promotions/Promotions.types'
import { usePromotionsQuery } from '../../../../../pages/Promotions/pages/PromotionCodes'
import type { Recommendation } from '../../../Recommendations.types'
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss'
import freeShipping from '../assets/free-shipping.png'

export const useFreeShippingRecommendation = () => {
  const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss()
  const { promotionsQuery } = usePromotionsQuery()
  const promotions = promotionsQuery.data?.promotions as Promotion[] | undefined

  const alreadyHasFreeShippingPromoActive = promotions?.some(
    (promo) => promo.discount.type === 'FREE_SHIPPING' && promo.status.type === 'LIVE',
  )

  return {
    freeShippingRecommendation: {
      id: 'freeShipping',
      enabled: recommendationsDismiss.freeShipping.visible && !alreadyHasFreeShippingPromoActive,
      isLoading: promotionsQuery.isInitialLoading,
      suggestion: (
        <Suggestion
          title="Offer free shipping on large orders to increase sales"
          description="Offering free shipping on larger orders can boost sales by up to 50%."
          imageUrl={freeShipping}
          buttonLabel="Offer free shipping on large orders"
          buttonTo={`${routing.promotions.promotionCodes.create.self}?mode=free-shipping`}
          analytics="freeShipping"
          onDismiss={createOnDismiss(recommendationsDismiss.freeShipping.dismiss)}
        />
      ),
    } satisfies Recommendation,
  }
}
